<template>
  <v-container id="fcreate">
    <v-row>
      <v-col>
        <div class="text-h3 mb-2" v-text="getTitle" />
      </v-col>
    </v-row>
    <v-row>
      <v-form v-model="valid" ref="form" style="width: 100%">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.name"
                label="Название"
                required
                outlined
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.description"
                label="Описание"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
          </v-row>
          <v-row
            v-for="(v, i) in getPermissionsByGroups"
            :key="`tables-perms-${i}`"
          >
            <v-col cols="12">
              <v-simple-table fixed-header class="elevation-1 menu-list">
                <thead>
                  <tr>
                    <th>{{ v.name }}</th>
                    <th>По привязанным</th>
                    <th>По привязке из табеля</th>
                    <th>По всем филиалам</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in getPermissionsRows(v.name)"
                    :key="`hecyz-${index}`"
                  >
                    <td>
                      {{ item.name }}
                    </td>
                    <td colspan="3">
                      <v-radio-group
                        column
                        :value="getDefaultValueByEditPage(item.id)"
                      >
                        <div class="d-flex justify-space-around">
                          <v-radio
                            value="filials"
                            :input-value="
                              getDefaultValueByEditPage(item.id, 'filials')
                            "
                            @change="
                              togglePermission(item.id, 'filials', $event)
                            "
                          />
                          <v-radio
                            value="schedules"
                            :input-value="
                              getDefaultValueByEditPage(item.id, 'schedules')
                            "
                            @change="
                              togglePermission(item.id, 'schedules', $event)
                            "
                          />
                          <v-radio
                            value="all"
                            :input-value="
                              getDefaultValueByEditPage(item.id, 'all')
                            "
                            @change="togglePermission(item.id, 'all', $event)"
                          />
                        </div>
                      </v-radio-group>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-row>
      <v-col cols="12" md="7">
        <v-btn block color="primary" @click="submit">
          Создать
        </v-btn>
        <v-btn block color="success" @click="submit(false)">
          Применить
        </v-btn>
        <v-btn block color="error" @click="$router.push('/roles')">
          Отмена
        </v-btn>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Измемнения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'

  export default {
    mixins: [rules],
    data () {
      return {
        data: {
          name: '',
          description: '',
          permissions: [],
        },
        permissions: [],
        loading: false,
        snackbar: false,
        snackbarSuccess: false,
      }
    },
    computed: {
      ...mapGetters({
        getRoles: 'roles/getRoles',
        getRolesSingle: 'roles/getRolesSingle',
        getPermissions: 'permissions/getPermissions',
      }),
      getTitle () {
        return this.getEditId ? 'Редактировать роль' : 'Создать роль'
      },
      getPermissionsByGroups () {
        const groups = Array.from(
          new Set(this.getPermissions.map((v) => v.group)),
        )
        return groups.map((perm) => {
          const permObj = {
            name: perm,
          }
          const identificators = []

          this.getPermissions.forEach((v) => {
            if (v.group === perm) identificators.push({ id: v.id, name: v.name })
          })

          permObj.ids = identificators
          return permObj
        })
      },
      getEditId () {
        return this.$route.params.id || null
      },
    },
    created () {
      this.$store.dispatch('permissions/fetchPermissions', {
        limit: 1000,
        offset: 0,
        page: 0,
      })

      /**
       * Если мы перешли на роут с id то фетчим роль и отправляем данные прав в data.permissions
       */
      if (this.getEditId) {
        this.$store.dispatch('roles/fetchSingleRole', this.getEditId).then(() => {
          this.data.name = this.getRolesSingle.name
          this.data.description = this.getRolesSingle.description
          this.data.permissions = this.getRolesSingle.permissions.map((v) => {
            return {
              permissionId: v.id,
              type: v.type,
            }
          })
        })
      }
    },
    beforeDestroy () {
      this.$store.commit('roles/clearRoleSingle')
    },
    methods: {
      async submit (redirect = true) {
        this.loading = true

        const validate = await this.$refs.form.validate()

        if (!this.getEditId) {
          /**
           * Создаем роль
           */
          if (validate) {
            try {
              const res = await this.$store.dispatch('roles/createRole', this.data)
              if (res.status === 200) {
                this.$router.push('/roles')
              }
            } catch (e) { console.log(e) }
            this.loading = false
          } else {
            this.toggleSnackbar()
          }
        } else {
          /**
           * Редактируем роль
           */
          if (validate) {
            try {
              this.data.sortOrder = this.getRolesSingle.sortOrder
              this.data.status = this.getRolesSingle.status
              const res = await this.$store.dispatch('roles/editRole', { data: this.data, id: this.getEditId })

              if (res.status === 200 && redirect) {
                this.$router.push('/roles/' + this.getEditId)
              } else {
                this.snackbarSuccess = true
                setTimeout(() => {
                  this.snackbarSuccess = false
                }, 3000)
              }
            } catch (error) {
              console.log(error)
            }

            this.loading = false
          } else {
            this.toggleSnackbar()
          }
        }
      },
      getPermissionsRows (group) {
        return this.getPermissions
          .filter((v) => v.group === group)
          .map((v) => {
            return {
              id: v.id,
              name: v.name,
            }
          })
      },
      toggleSnackbar () {
        this.snackbar = true
        document.getElementById('fcreate').scrollIntoView({
          behavior: 'smooth',
        })

        setTimeout(() => {
          this.snackbar = false
        }, 3000)
      },
      togglePermission (id, type, event) {
        this.data.permissions = this.data.permissions.filter(
          (v) => v.permissionId !== id,
        )
        this.data.permissions.push({
          permissionId: id,
          type: type,
        })
      // if (event) {
      //   this.data.permissions.push({
      //     permissionId: id,
      //     type: type,
      //   })
      // } else {
      //   this.data.permissions = this.data.permissions.filter(v => !(v.permissionId === id && v.type === type))
      // }
      },
      getDefaultValueByEditPage (id) {
        return this.getEditId && this.getRolesSingle
          ? this.getRolesSingle.permissions.find((v) => {
            return v.id === id
          }).type
          : false
      },
    },
  }
</script>
